let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls, toKebabCase } from '@utils/utils';

const elementTag = 'spw-message';

const argTypes = withComponentControls(componentsData, { tag: elementTag });

const meta: Meta = {
  title: 'Composants/Message',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Affiche des notifications ou des informations importantes à l'utilisateur.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/039ae1-message)
        `,
      },
    },
  },
};

export default meta;

function htmlContent(slot) {
  return /* HTML */ `${slot}`;
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);
  const hasSlot = true;
  const slottedLabel = 'content';

  Object.entries(args).forEach(([key, val]) => {
    if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    } else {
      if (key !== slottedLabel) {
        element.setAttribute(toKebabCase(key), val as string);
      }
    }
  });

  if (hasSlot) {
    element.innerHTML = htmlContent(args[slottedLabel]);
  }

  return element;
};

const commonArgs = {
  messageTitle: 'Titre du message',
  isDismissable: true,
  content: 'Contenu du message',
};

export const Default = Template.bind({});
Default.args = {
  ...commonArgs,
  messageId: '1',
  variant: 'default',
};

export const Success = Template.bind({});
Success.args = {
  ...commonArgs,
  messageId: '2',
  variant: 'success',
};

export const Alert = Template.bind({});
Alert.args = {
  ...commonArgs,
  messageId: '3',
  variant: 'alert',
};

export const Info = Template.bind({});
Info.args = {
  ...commonArgs,
  messageId: '4',
  variant: 'info',
};

export const Warning = Template.bind({});
Warning.args = {
  ...commonArgs,
  messageId: '5',
  variant: 'warning',
};
